import { Link } from 'react-router-dom';
import PolicyLayout from '../components/PolicyLayout';
import { ADDRESS, COMPANY_NAME, PRODUCT_NAME, SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function RefundPolicy() {
  return (
    <PolicyLayout
      title="Refund Policy"
      intro={`When and how ${COMPANY_NAME} refunds paid support services purchased through ${SITE_DOMAIN}.`}
    >
      <h2>1. Scope</h2>
      <p>
        This policy applies only to paid support services billed directly by {COMPANY_NAME} under the{' '}
        {SITE_NAME} name, such as single sessions and support plans. It does not cover {PRODUCT_NAME}{' '}
        licences, subscriptions, or products bought from a software publisher or another retailer — please
        follow the refund terms of the company you paid.
      </p>

      <h2>2. Eligible refunds</h2>
      <ul>
        <li>
          <strong>Unresolved issue:</strong> if we cannot resolve the issue you paid us to fix, you may
          request a full refund within 7 days of purchase.
        </li>
        <li>
          <strong>Cancellation before work starts:</strong> cancel before your session begins for a full refund.
        </li>
        <li>
          <strong>Billing errors:</strong> duplicate charges or amounts different from what you agreed are refunded in full once verified.
        </li>
        <li>
          <strong>Support plans:</strong> unused plans may be cancelled within 7 days for a full refund.
          After that, a partial refund may be offered based on the remaining term and support already provided.
        </li>
      </ul>

      <h2>3. Non-refundable situations</h2>
      <ul>
        <li>Services that were completed and resolved the issue.</li>
        <li>Requests made more than 7 days after purchase.</li>
        <li>Problems caused by hardware failure, third-party service outages, or changes made after the session ended.</li>
        <li>Issues outside the scope of the support you purchased.</li>
      </ul>

      <h2>4. How to request a refund</h2>
      <ol>
        <li>Contact us via live chat or the <Link to="/contact-us">contact form</Link>.</li>
        <li>Include your name, purchase date, the email used at purchase, and the reason for your request.</li>
        <li>We review requests within 3 business days and let you know the outcome.</li>
      </ol>

      <h2>5. Processing</h2>
      <p>
        Approved refunds are issued to the original payment method. Depending on your bank or card
        provider, funds usually appear within 5–10 business days.
      </p>

      <h2>6. Contact</h2>
      <p>
        {COMPANY_NAME}, {ADDRESS}. Live chat is available 24/7.
      </p>
    </PolicyLayout>
  );
}
